import { v4 as uuidv4 } from 'uuid';

const recipesStore = [
    {
        id: uuidv4(),
        name: "Roast Beef Steak",
        imgSrc: '1694649007.jpg',
        url: '1694649007',
        related: ['1667407563', '917603352'],
        steps: [
            "Mix garlic, salt, cayenne pepper and black pepper in a small bowl.",
            "Rub the steak with this mixture to absorb it and put it in the refrigerator for several hours.",
            "Heat the grill, then put the steak inside and press it down a little.",
            "Flip it to brown on both sides, then serve it with french fries and salad.",
        ],
        ingredients: [
            "1 kilo Beef Sirloin Steak - 1kg",
            "5 crushed cloves Fresh Garlic Local - 1kg",
            "3 tablespoons Crystal Sunflower Oil - 800ml",
            "2 teaspoons Isis Salt - 70g",
            "1 teaspoon Isis Red Hot Pepper 30g",
            "half teaspoon Al Doha Black Pepper Powder - 70g",
        ],
        ingredientProducts: ['LG00403.jpg', 'LG00118.jpg', 'LG00060.jpg'],
    },
    {
        id: uuidv4(),
        name: "Fast Dounts",
        imgSrc: '187846941.jpg',
        url: '187846941',
        related: ['1508301284', '354944336'],
        steps: [
            "Mix the ingredients for the dough in an electric mixer, and mix only until blended",
            "Formed into ropes, then braided",
            "Fry in abundant oil until golden brown",
            "Sprinkle with powdered sugar and serve",
        ],
        ingredients: [
            "2 tablespoons Al-Asil Sunflower Oil - 1.5l",
            "130 g Metro Flour All Purpose -1kg",
            "400 ml Nestle Water 600M*20 Bottle",
            "130 g Metro Flour All Purpose -1kg",
            "For decoration El-Marmar Powder Sugar 1Kg",
        ],
        ingredientProducts:  ['LG00403.jpg', 'LG00118.jpg', 'LG00060.jpg'],
    },
    {
        id: uuidv4(),
        name: "Mango Ice Cream",
        imgSrc: '1965318045.jpg',
        url: '1965318045',
        related: [],
        steps: [],
        ingredients: [],
        ingredientProducts: []
    },
    {
        id: uuidv4(),
        name: "Pancakes",
        imgSrc: '1669586656.jpg',
        url: '1669586656',
    },
    {
        id: uuidv4(),
        name: "Spinach Potato Casserole",
        imgSrc: '354944336.jpg',
        url: '354944336',
    },
    {
        id: uuidv4(),
        name: "Kahk Eid",
        imgSrc: '858883423.jpg',
        url: '858883423',
    },
    {
        id: uuidv4(),
        name: "Shrimp Konafa",
        imgSrc: '1406663966.jpg',
        url: '1406663966',
    },
    {
        id: uuidv4(),
        name: "Foul with Eggs",
        imgSrc: '1191840965.jpg',
        url: '1191840965',
    },
    {
        id: uuidv4(),
        name: "Lebanese tabbouleh",
        imgSrc: '1508301284.jpg',
        url: '1508301284',
    },
    {
        id: uuidv4(),
        name: "Baklava",
        imgSrc: '1667407563.jpg',
        url: '1667407563',
    },
    {
        id: uuidv4(),
        name: "Baked Ribs",
        imgSrc: '687679594.jpg',
        url: '1667407563',
    },
    {
        id: uuidv4(),
        name: "Steak with Green Peppers",
        imgSrc: '1670669915.jpg',
        url: '1670669915',
    },
    {
        id: uuidv4(),
        name: "Shish Tawook Chicken",
        imgSrc: '885766107.jpg',
        url: '885766107',
    },
    {
        id: uuidv4(),
        name: "Nabulsi Knafeh",
        imgSrc: '1950166467.jpg',
        url: '1950166467',
    },
    {
        id: uuidv4(),
        name: "Potato Soup",
        imgSrc: '546268128.jpg',
        url: '546268128',
    },
    {
        id: uuidv4(),
        name: "Hummus Salad With Cheese",
        imgSrc: '1511822143.jpg',
        url: '1511822143',
    },
    {
        id: uuidv4(),
        name: "Foul Iskandrany",
        imgSrc: '561517681.jpg',
        url: '561517681',
    },
    {
        id: uuidv4(),
        name: "Cajun Chicken Pasta",
        imgSrc: '389242390.jpeg',
        url: '389242390',
    },
    {
        id: uuidv4(),
        name: "Fattah",
        imgSrc: '750991082.jpeg',
        url: '750991082',
    },
    {
        id: uuidv4(),
        name: "Duck Breasts with Vermicelli",
        imgSrc: '881063702.jpg',
        url: '881063702',
    },
    {
        id: uuidv4(),
        name: "Dips",
        imgSrc: '1074409802.jpg',
        url: '1074409802',
    },
    {
        id: uuidv4(),
        name: "Shrimp Konafa",
        imgSrc: '267654547.jpg',
        url: '267654547',
    },
    {
        id: uuidv4(),
        name: "Roast Beef",
        imgSrc: '734703999.jpg',
        url: '734703999',
    },
    {
        id: uuidv4(),
        name: "Turkey Rolls",
        imgSrc: '1152514489.jpg',
        url: '1152514489',
    },
    {
        id: uuidv4(),
        name: "Dinner for Two",
        imgSrc: '862291444.jpg',
        url: '862291444',
    },
    {
        id: uuidv4(),
        name: "Coconut Biscuits",
        imgSrc: '917603352.jpg',
        url: '917603352',
    },
    {
        id: uuidv4(),
        name: "Pesto Pasta with Salmon",
        imgSrc: '431305615.jpg',
        url: '431305615',
    },
    {
        id: uuidv4(),
        name: "Baked Ribs",
        imgSrc: '407593851.jpg',
        url: '407593851',
    },
    {
        id: uuidv4(),
        name: "Steak with Pepper Sauce",
        imgSrc: '1320898534.jpg',
        url: '1320898534',
    },
    {
        id: uuidv4(),
        name: "Chicken Fattah with Yogurt",
        imgSrc: '1013905503.jpg',
        url: '1013905503',
    },
    {
        id: uuidv4(),
        name: "Barbeque Burger",
        imgSrc: '407543291.jpg',
        url: '407543291',
    },
];

export default recipesStore;